import {
  red,
  blue,
  lime,
  amber,
  lightGreen,
  lightBlue,
  purple,
  teal,
  cyan,
  brown,
  grey,
  pink
} from '@material-ui/core/colors'
import { fade } from '@material-ui/core/styles/colorManipulator'

export const colors = (index, shade, opacity) => {
  let palettes = [
    red[shade],
    blue[shade],
    lime[shade],
    amber[shade],
    lightGreen[shade],
    lightBlue[shade],
    purple[shade],
    teal[shade],
    cyan[shade],
    brown[shade],
    grey[shade],
    pink[shade]
  ]
  return fade(palettes[index], opacity ? opacity : 1)
}
